import React from "react";
import { WebhookLog } from "@/pages/AdminDashboard";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function WebhookLogPage() {
  return (
    <LegacyHost
      title="Webhook Log"
      migratedFrom="Editorial desk · Webhook log"
      testid="os-system-webhook-log"
    >
      <WebhookLog />
    </LegacyHost>
  );
}
